<template>
  <PageTemplate
    :datas="datas"
    :nv-items="nvItems"
    ref="page"
    :lang="lang"
    @homeClick="homeClick"
    page-name="service"
  />
</template>

<script>
import PageTemplate from "@/components/PageTemplate.vue";
import { getService } from "@/api/data.js";
export default {
  components: {
    PageTemplate,
  },
  props: ["lang"],
  data() {
    return {
      datas: [],
      activeItem: 0,
      nvItems: [
        {
          name: "首页",
          path: "/",
          enName: "Home",
        },
        {
          name: "服务",
          path: "",
          enName: "Service",
        },
      ],
    };
  },

  mounted() {
    console.log("---------------");
    this.getData();
  },
  methods: {
    setActiveItem(id) {
      this.$refs.page.setActiveItem(id);
    },
    menuItemClick(e) {
      this.activeItem = parseInt(e);
    },
    homeClick() {
      this.$emit("toHome");
    },
    getData() {
      let that = this;
      getService()
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            let data = response.data.data;
            that.datas = data;
          } else {
            that.datas = [];
          }
        })
        .catch((error) => {
          console.log(error);
          that.datas = [];
        });
    },
  },
};
</script>

<style scoped></style>
